export default "__VITE_ASSET__BcqhulaL__"